import React from 'react';
import LoginSidebar from '../../components/Login/LoginSidebar';

const BuildProfileLayout = (props) => {
	return (
		<section className='login-section build-profile'>
			<div className='lg-left'>
				<LoginSidebar />
			</div>
			<div className='lg-right buildprofile-left'>{props.children}</div>
		</section>
	);
};

export default BuildProfileLayout;
